import React from "react"
import { Box, Flex } from "@chakra-ui/react"
import Wrapper from "components/layout/wrapper"

export default function Row({ block, colorMode = "light" }) {
    const gapHorizontal = block.gapHorizontal ? block.gapHorizontal : "20px"
    const gapVertical = block.gapVerticalMobile ? block.gapVerticalMobile : "10px"
    return (
        <Wrapper
            className={`rowMatrixBlock colorMode--${colorMode} ${block.customClass ? block.customClass : ""}`}
            py="10px"
        >
            <Flex w="100%" direction={{ base: "column", md: "row" }} gap={{ base: gapVertical, md: gapHorizontal }}>
                {block.columnsContent.map((column, index) => {
                    return (
                        <React.Fragment key={index}>
                            <Box
                                className={`body box-${index}`}
                                flexGrow={1}
                                flexShrink={1}
                                flexBasis={0}
                                dangerouslySetInnerHTML={{ __html: column.columnContent }}
                            />
                            {block.addDividers && index < block.columnsContent.length - 1 && (
                                <Box flex="0 1 auto" padding={0}>
                                    <Box width="1px" className="verticalDivider" height="100%"></Box>
                                </Box>
                            )}
                        </React.Fragment>
                    )
                })}
            </Flex>
        </Wrapper>
    )
}
